import { render, staticRenderFns } from "./FAdminCollapse.vue?vue&type=template&id=d2a48712"
import script from "./FAdminCollapse.vue?vue&type=script&lang=js"
export * from "./FAdminCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports